/* ============================================================
   Offe: photo arrows on product cards (collection pages)
   snippets/product-card.liquid lists each card's photos in
   data-offe-gallery ("720px-url 1200px-url|..."). This adds a
   prev / next arrow pair to cards with 2+ photos and swaps the
   card's main photo in place. Phones can also swipe the photo.
   Loaded by the grid_fill custom-liquid section in
   templates/collection.json; styles in assets/custom-card-gallery.css.

   Speed (Oct 28, 2026): the arrow layer used to be measured right
   after each card got it, which made the browser re-lay-out the
   whole page once per card (about 4 seconds on Shop All, and it held
   up everything after it, including the % off stickers). Now one
   shared ResizeObserver measures every card in a single pass and
   then positions them all, so the page is laid out once.
   ============================================================ */
(function () {
  var ARROW =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function parse(media) {
    return (media.getAttribute('data-offe-gallery') || '')
      .split('|')
      .map(function (pair) {
        var p = pair.trim().split(' ');
        return p[0] ? { small: p[0], large: p[1] || p[0] } : null;
      })
      .filter(Boolean);
  }

  function preload(photo) {
    if (!photo || photo.loaded) return;
    photo.loaded = true;
    var i = new Image();
    i.srcset = photo.small + ' 720w, ' + photo.large + ' 1200w';
    i.sizes = '(min-width: 990px) 25vw, 50vw';
    i.src = photo.small;
  }

  function show(media, photos, index) {
    var img = media.querySelector('img.media--first');
    if (!img) return;
    var n = photos.length;
    index = ((index % n) + n) % n;
    media._offeIndex = index;
    var p = photos[index];
    img.removeAttribute('loading');
    img.srcset = p.small + ' 720w, ' + p.large + ' 1200w';
    img.src = p.small;
    // the hover "second photo" would sit on top of the arrows' choice
    media.classList.add('offe-g--browsing');
    var dots = media._offeNav ? media._offeNav.querySelectorAll('.offe-g__dot') : [];
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === index);
    preload(photos[(index + 1) % n]);
    preload(photos[(index - 1 + n) % n]);
  }

  // Position every arrow layer over its photo: read all sizes first, then
  // write all styles, so the page is laid out once, not once per card.
  function placeAll(list) {
    var boxes = [];
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (!m._offeNav) continue;
      boxes.push([m._offeNav, m.offsetTop, m.offsetLeft, m.offsetWidth, m.offsetHeight]);
    }
    for (var j = 0; j < boxes.length; j++) {
      var b = boxes[j], s = b[0].style;
      s.top = b[1] + 'px';
      s.left = b[2] + 'px';
      s.width = b[3] + 'px';
      s.height = b[4] + 'px';
    }
  }

  var ro = window.ResizeObserver
    ? new ResizeObserver(function (entries) {
        placeAll(entries.map(function (e) { return e.target; }));
      })
    : null;

  function setup(media) {
    if (media._offeG) return;
    var photos = parse(media);
    if (photos.length < 2) return;
    media._offeG = true;
    media._offeIndex = 0;
    photos[0].loaded = true;
    media.classList.add('offe-g');

    var label = (media.closest('product-card') || document).querySelector('.product-card__title a');
    var name = label ? label.textContent.trim() : 'product';

    function button(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'offe-g__arrow offe-g__arrow--' + dir;
      b.setAttribute('aria-label', (dir === 'prev' ? 'Previous photo of ' : 'Next photo of ') + name);
      b.innerHTML = ARROW;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(media, photos, media._offeIndex + (dir === 'prev' ? -1 : 1));
      });
      return b;
    }
    // The arrows live in a layer on the card itself, not inside the photo
    // box: the photo box is its own stacking layer (z-index 0), so anything
    // in it sits under the card's full-size link and can't be clicked.
    var card = media.closest('product-card') || media.parentElement;
    var nav = document.createElement('div');
    nav.className = 'offe-g__nav';
    nav.appendChild(button('prev'));
    nav.appendChild(button('next'));

    var dots = document.createElement('div');
    dots.className = 'offe-g__dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < photos.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'offe-g__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(dot);
    }
    nav.appendChild(dots);
    card.appendChild(nav);
    media._offeNav = nav;
    // positioned by the shared observer (it reports every new photo once)
    if (ro) ro.observe(media);

    card.addEventListener('mouseenter', function () { preload(photos[1]); }, { once: true });

    // swipe on touch screens; a swipe must not also open the product
    var x0 = null, y0 = null, swiped = false;
    card.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.product-card__media, .product-card__link-overlay')) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; swiped = false;
    }, { passive: true });
    card.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        swiped = true;
        show(media, photos, media._offeIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
    card.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('[data-offe-gallery]');
    var added = [];
    for (var i = 0; i < list.length; i++) {
      if (!list[i]._offeG) { setup(list[i]); if (list[i]._offeG) added.push(list[i]); }
    }
    if (!ro && added.length) placeAll(added);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }

  function init() {
    scan();
    var container = document.getElementById('ProductGridContainer') || document.body;
    new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
